import { StrictMode, Suspense, lazy } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';
import './styles/index.css';

/**
 * The marketing site is one page and needs no router. The certificate system
 * does, so the router, Supabase client and QR library live in a chunk that is
 * only fetched on /verify and /admin — the homepage never downloads them.
 */
const CertificateRoutes = lazy(() => import('./CertificateRoutes'));

const isCertificateRoute = /^\/(verify|admin)(\/|$)/.test(window.location.pathname);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    {isCertificateRoute ? (
      <Suspense fallback={null}>
        <CertificateRoutes />
      </Suspense>
    ) : (
      <App />
    )}
  </StrictMode>
);
